import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { queryMe } from '../me/api';
import { GenerationType } from '../video-model/model-spec';
import { generationDataFamilyAtom } from '../video/store';

const getFrameImageAtom = (accountId: string) =>
  generationDataFamilyAtom({
    accountId,
    type: GenerationType.Frame,
  });

export function useReadFrameImagePageData() {
  const { data } = useQuery(queryMe);

  return useAtomCallback(
    useCallback(
      (get) => {
        return get(getFrameImageAtom(data.name));
      },
      [data.name],
    ),
  );
}

export function useSetFrameImagePageData() {
  const { data } = useQuery(queryMe);

  return useSetAtom(getFrameImageAtom(data.name));
}
